import { parseLegalDocument } from '../../legal/parseLegalDocument';
import { LegalMarkdown } from './LegalMarkdown';
import { LegalProse } from './LegalProse';

export function LegalPage({ source }: { source: string }) {
  const doc = parseLegalDocument(source);
  return (
    <LegalProse title={doc.title}>
      <LegalMarkdown doc={doc} />
    </LegalProse>
  );
}
